import initSessionStorage from "./initSessionStorage";
// TODO: pending to be properly migrated away from using test store.
import { readSessionStorage } from "../../test/store";
/**
 * Imperative API for managing session storage items.
 *
 * Also, provides methods for listening to session storage events.
 *
 * When accessing the session storage inside a React Component, better use the
 * [useSessionStorage](./useSessionStorage.md) hook.
 */ export default {
    /**
   * Reads the value of the specified item from session storage.
   */ get (/** The sessionStorage config object for `@sail/data`. */ config, name, reports) {
        var _readSessionStorage_get;
        var _initSessionStorage_sessionStorage_get;
        const result = (_initSessionStorage_sessionStorage_get = initSessionStorage(config, reports).sessionStorage.get(name)) !== null && _initSessionStorage_sessionStorage_get !== void 0 ? _initSessionStorage_sessionStorage_get : null;
        (_readSessionStorage_get = readSessionStorage.get(name)) === null || _readSessionStorage_get === void 0 ? void 0 : _readSessionStorage_get.forEach((callback)=>{
            callback(name, result);
        });
        return result;
    },
    /**
   * Attempts to write the specified value to session storage.
   */ set (/** The sessionStorage config object for `@sail/data`. */ config, /** The name of the item to be set. */ key, /**
     * The new value to be set. If value is `null`, the item will be deleted.
     */ value, reports) {
        if (value == null) {
            // returning a promise to match our localStorage abstraction
            return Promise.resolve(initSessionStorage(config, reports).sessionStorage.remove(key));
        }
        // returning a promise to match our localStorage abstraction
        return Promise.resolve(initSessionStorage(config, reports).sessionStorage.set(key, value));
    },
    /**
   * Removes the specified item from session storage.
   */ remove (/** The sessionStorage config object for `@sail/data`. */ config, /** The name of the item to be removed. */ name, reports) {
        return initSessionStorage(config, reports).sessionStorage.remove(name);
    },
    /**
   * Listens to session storage events. The method accepts a callback that will be
   * called whenever an item is updated or deleted.
   */ subscribe (/** The sessionStorage config object for `@sail/data`. */ config, callback, reports) {
        initSessionStorage(config, reports).eventListener.addListener(callback);
    },
    /**
   * Unsubscribes from session storage events. The callback should be the same
   * one used for subscribing to session storage events.
   */ unsubscribe (/** The sessionStorage config object for `@sail/data`. */ config, callback, reports) {
        initSessionStorage(config, reports).eventListener.removeListener(callback);
    }
};

//# sourceMappingURL=sessionStorage.js.map